import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import iconMixin from 'styles/utils/iconMixin';

const Span = styled.span`
  ${iconMixin('11px')};
  padding-left: 1px;
  margin-top: -1px;
  color: ${props => props.theme.colors.requiredIcon};
`;

const RequiredIcon = ({ mandatory, readOnly }) => {
  if (!mandatory || readOnly) {
    return null;
  }
  return <Span>grade</Span>;
};
RequiredIcon.propTypes = {
  mandatory: PropTypes.bool,
  readOnly: PropTypes.bool,
};
RequiredIcon.defaultProps = {
  mandatory: false,
  readOnly: false,
};
export default RequiredIcon;
